import React from 'react';
import PropTypes from 'prop-types';
import { NavBar } from '../navigation/nav-bar';
import { OnyxAnnouncementBar } from './OnyxAnnouncementBar';
import { OnyxBrandMark } from './OnyxBrandMark';

/**
 * App navigation shell. Wraps existing NavBar chrome while migration completes;
 * announcement bar + brand mark are first-class DS pieces.
 */
export function OnyxNav({
  announcement,
  showNav = true,
  className = '',
}) {
  return (
    <div
      className={['onyx-nav', className].filter(Boolean).join(' ')}
      data-testid="onyx-nav"
    >
      <OnyxAnnouncementBar message={announcement} />
      {showNav ? <NavBar /> : (
        <div className="onyx-nav__brand-only" data-testid="onyx-nav-brand-only">
          <OnyxBrandMark size={28} />
        </div>
      )}
    </div>
  );
}

OnyxNav.propTypes = {
  announcement: PropTypes.string,
  showNav: PropTypes.bool,
  className: PropTypes.string,
};
